export const EndOfEmploymentSettlementEnums = {
  NONE: 'NONE',
  PAY_OUT: 'PAY_OUT',
  SETTLE: 'SETTLE',
  TRANSFER: 'TRANSFER'
} as const;
